var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"spark-input-label"},[_vm._v("Notes")]),_c('a-textarea',{attrs:{"autosize":"","value":_vm.notes},on:{"change":_vm.notesChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }